export const BREADCRUMB_TAG_NAME = "breadcrumb" as const;

export const BREADCRUMB_ITEM_TAG_NAME = "breadcrumb-item" as const;
